import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  DislikeFilled,
  DislikeOutlined,
  LikeFilled,
  LikeOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Card, Comment, message, Row, Space, Tag, Tooltip } from "antd";
import { createElement, useState } from "react";

import { NewThreadModal } from "./NewThreadModal";
const fakeLikes = Math.floor(Date.now() / 6000) - 269080000;

console.log(fakeLikes);

export function Feed(props: { onCreate: (message: string) => void }) {
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState(null);

  function like() {
    setAction("liked");
  }

  function dislike() {
    setAction("disliked");
  }

  const actions = [
    <Tooltip key="comment-basic-like" title="Like">
      <span onClick={like}>
        {createElement(action === "liked" ? LikeFilled : LikeOutlined)}
        <span className="comment-action">{fakeLikes + (action === "liked" ? 1 : 0)}</span>
      </span>
    </Tooltip>,
    <Tooltip key="comment-basic-dislike" title="Dislike">
      <span onClick={dislike}>
        {createElement(action === "disliked" ? DislikeFilled : DislikeOutlined)}
        <span className="comment-action">{Math.floor(fakeLikes / 200) + (action === "disliked" ? 1 : 0)}</span>
      </span>
    </Tooltip>,
    <span
      onClick={() => {
        message.warn({ content: "Must have at least one new thread to reply to other comments." });
      }}
      key="comment-basic-reply-to"
    >
      Reply to
    </span>,
  ];

  return (
    <>
      <div style={{ fontSize: 18, fontFamily: "azonix", margin: 12 }}>Your Feed</div>
      <Card style={{ margin: 12 }}>
        <Comment
          actions={actions}
          author={
            <Space size="small">
              <span>Cancel™ Admin</span>
              <CheckCircleTwoTone />
            </Space>
          }
          avatar={<CloseCircleTwoTone style={{ fontSize: 32 }} twoToneColor={["red", "#ffcccb"]} />}
          content={
            <p>
              Welcome to Cancel™! I cannot wait to get to know each and every one of you by all the creative and
              inclusive posts you author!
            </p>
          }
          datetime={<span>February 28, 2021, 11:58am</span>}
        />
      </Card>
      <Row style={{ margin: 12 }}>
        <Button block type="dashed" style={{ height: 48 }} onClick={() => setShowModal(true)}>
          New Thread
        </Button>
      </Row>
      {showModal ? <NewThreadModal onCancel={() => setShowModal(false)} onCreate={props.onCreate} /> : null}
    </>
  );
}
